import styled from "styled-components";
import { MainSection,  } from "../../../components/01_config/MainStyles";
import { Link } from "react-router-dom";
import { colors } from "../../../components/01_config/Colors";
import { sizes } from "../../../components/01_config/Sizes";


const SquaresSection = styled(MainSection)`
    justify-content: center;
    margin: 0;
    @media(max-width: 800px) {
        flex-direction: column;
        align-items: center;
    }
`

const Square = styled(Link)`
    position: relative;
    width: 300px;
    height: 300px;
    background-color: ${colors.greyLight};
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    gap: 20px;
    cursor: pointer;
    text-decoration: none;
    &:active {
        transform: translate(2px, 2px);
    }
`

const Image = styled.img`
    height: 100%;
    width: 100%;
    opacity: 0.8;
    &:hover {
        opacity: 1;
    };
`

const Title = styled.div`
    position: absolute;
    width: 100%;
    padding: 8px 0;
    // top: 50%;
    // transform: translateY(-50%);
    bottom: 0px;
    right: auto;
    color: white;
    background-color: rgba(143, 143, 143, 0.4);
    font-size: 2.5rem;
    font-weight: 700;
    text-align: center;
`

export { SquaresSection, Square, Image, Title }